let send = async (m) => { throw Error("MessageBroker is not initialized"); };
export function setSendFunction(f) {
    send = f;
}
export class Message {
    async send() {
        return await send(this);
    }
}
export class StatelessMessage extends Message {
}
export class SharedMessage extends Message {
}
export class SharedStatelessMessage extends StatelessMessage {
}
export class ClearMessageState extends StatelessMessage {
    constructor(m) {
        super();
        this.subject = m;
    }
}
